import { Block, CRIcon, CRRender } from '@/components/crRender'
import './style.css'
import { IsListNotEmpty } from '@/utils/varsManipulations'
import { Checkbox } from '@/components/Exporter'
import { translate } from '@/utils/langUtils'


const OptionalServices = ({ ServicesList, title, selectedItems, handleToggle }) => 
        <Block isRender={IsListNotEmpty(ServicesList)} className="qd-section">
            <h3 className="qd-section-title">{translate(title)}</h3>
            <div className="qd-addons-grid">
                {ServicesList?.map((item) => (
                    <div key={item.id} className={`qd-addon-card ${(selectedItems.includes(item.id) || item?.isSelected) ? "qd-addon-selected" : ""}`} onClick={() => !item?.isSelected && handleToggle(item.id)} >
                        <div className="qd-addon-checkbox">
                            <CRRender isRender={!item?.isSelected}>
                                <Checkbox
                                    onApply={() => handleToggle(item.id)}
                                    value={selectedItems.includes(item.id)}
                                    label={item.name}
                                    className="relative-checkbox"
                                />
                            </CRRender>
                            <CRIcon isRender={item?.isSelected} icon="icons8:checked" width={20} height={20} />
                        </div>
                        <div className="qd-addon-content">
                            <div className="qd-addon-header">
                                <h4 className="qd-addon-name">{item.name}</h4>
                                <span className="qd-addon-price">${item.price}.00</span>
                            </div>
                            <p className="qd-addon-description">{item.description ||item.reason}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Block>

export default OptionalServices